export default "__VITE_ASSET__BKvTRohV__"